"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Table_1 = require("@material-ui/core/Table");

var TableFooter_1 = require("@material-ui/core/TableFooter");

var TableHead_1 = require("@material-ui/core/TableHead");

var React = require("react");

var GridBody_1 = require("./GridBody");

var GridHeader_1 = require("./GridHeader");

exports.DataGridTable = function (props) {
  return React.createElement(Table_1["default"], {
    "data-testid": 'data-grid-table'
  }, React.createElement(TableHead_1["default"], null, React.createElement(GridHeader_1.GridHeader, {
    grid: props.grid
  })), React.createElement(GridBody_1.GridBody, {
    grid: props.grid,
    bodyRenderer: props.bodyRenderer,
    onRowClick: props.onRowClick
  }), props.footerRenderer !== null && React.createElement(TableFooter_1["default"], null, props.footerRenderer && props.footerRenderer(props.grid.state.aggregate)));
};